<section class="px-16 py-12.5 lg:w-126.5 bg-white rounded-lg text-center">
  <h2 class="text-[28px] font-bold mb-4">Create Court File Number</h2>

  <form [formGroup]="form">
    @if (isLocked()) {
      <app-ccs-input
        (onClickIcon)="unlockInput()"
        icon="lock"
        label="Court File Number"
        formControlName="fileNumber" />
      <p class="text-neutral-600 text-left text-xs mt-2">
        Auto-generated. Click the lock to edit manually.
      </p>
    } @else {
      <div class="mb-6">
        <app-dashboard-alert
          type="warning"
          [message]="`Editing the auto-generated number. Original: ${nextNumberToUse()}`" />
      </div>
      <app-ccs-input label="Court File Number" formControlName="fileNumber" />
      <p class="text-neutral-600 text-left text-xs">Manual entry mode.</p>
    }
    <div class="mt-10">
      <div class="flex justify-end gap-11">
        <ui-button mat-dialog-close class="w-full" [outline]="true"
          >Cancel</ui-button
        >
        <ui-button
          [mat-dialog-close]="form.controls.fileNumber.value"
          [disabled]="form.invalid"
          type="submit"
          class="w-full"
          >Confirm</ui-button
        >
      </div>
    </div>
  </form>
</section>
